import { useMutation } from "react-query";
import { editSingleSafe } from "../../../../actions/CarrierAgreementMgmt/Security";

const useEditSingleSafe = () => {
  return useMutation(editSingleSafe);
};
export default useEditSingleSafe;
